"use strict";

import PerformanceTimer from "/app/deps/hologram/assets/js/performance_timer.mjs";

const startTime = performance.now();

globalThis.Hologram.pageReachableFunctionDefs = (deps) => {
	const {
		Bitstring,
		ERTS,
		HologramBoxedError,
		HologramInterpreterError,
		Interpreter,
		MemoryStorage,
		Type,
		Utils,
	} = deps;

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.ContactPage",
		"__layout_module__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.atom("Elixir.BishopWeb.Blog.MainLayout");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.ContactPage",
		"__layout_props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.list([]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.ContactPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.ContactPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/contact-me");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.ContactPage",
		"action",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.atom("copy"),
					Type.matchPlaceholder(),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					Elixir_Hologram_JS["exec/1"](
						Type.bitstring(
							"navigator.clipboard.writeText('chrisjbishop155@gmail.com')",
						),
					);
					return context.vars.component_1;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.ContactPage",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("h1"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"text-4xl text-heading m-8 text-center",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Contact Me"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("p"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("flex items-center gap-2"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\nEmail: "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("a"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("link"),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("href"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mailto:chrisjbishop155@gmail.com",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("chrisjbishop155@gmail.com"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("button"),
													Type.list([
														Type.tuple([
															Type.bitstring("$click"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([Type.atom("copy")]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("cursor-pointer"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("svg"),
															Type.list([
																Type.tuple([
																	Type.bitstring("xmlns"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"http://www.w3.org/2000/svg",
																			),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("none"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("viewBox"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0 0 24 24"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("1.5"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("currentColor"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("size-6"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("path"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("stroke-linecap"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("round"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("stroke-linejoin"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("round"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("d"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n  "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.EmploymentPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.EmploymentPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/employment");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.HomePage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.HomePage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.MainLayout",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.MainLayout",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([Type.atom("doctype"), Type.bitstring("html")]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("html"),
											Type.list([
												Type.tuple([
													Type.bitstring("lang"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("en"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("head"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("charset"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("utf-8"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("title"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Chris Bishop"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("phx-track-static"),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/assets/css/app.css"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom("Elixir.Hologram.UI.Runtime"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("body"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"bg-gray-50 text-black min-h-screen",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("nav"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"navbar bg-white shadow-sm flex gap-6 px-4 py-2",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom("Elixir.Hologram.UI.Link"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("to"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.BishopWeb.Blog.HomePage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Home"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom("Elixir.Hologram.UI.Link"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("to"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.BishopWeb.Blog.PortfolioPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Portfolio"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom("Elixir.Hologram.UI.Link"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("to"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.BishopWeb.Blog.TechPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Technologies"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom("Elixir.Hologram.UI.Link"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("to"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.BishopWeb.Blog.EmploymentPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Employment History"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom("Elixir.Hologram.UI.Link"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("to"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.BishopWeb.Blog.QualificationsPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Qualifications"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom("Elixir.Hologram.UI.Link"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("to"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.BishopWeb.Blog.ContactPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Contact Me"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("p-16"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("main"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"card shadow-sm bg-white max-w-6xl mx-auto w-full",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("card-body"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("slot"),
																					Type.list([]),
																					Type.list([]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.PortfolioPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.PortfolioPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/portfolio");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.QualificationsPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.QualificationsPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/qualifications");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.TechPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"BishopWeb.Blog.TechPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/technologies");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Router.Helpers",
		"page_bundle_path",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("page_digest_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(Type.string("/hologram/page-"), {
							type: "binary",
						}),
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.page_digest_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(".js"), { type: "binary" }),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("to"),
								Type.list([
									Type.atom("module"),
									Type.atom("string"),
									Type.atom("tuple"),
								]),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("style"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("rel"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("class"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_Hologram_Router_Helpers["page_path/1"](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("to"),
																	),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("class"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("rel"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("rel"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("style"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("style"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$pointerdown"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__prefetch_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$click"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__load_prefetched_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page_mounted?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_mounted?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_digest"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_digest"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("initial_page?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("initial_page?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("csrf_token"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("csrf_token"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.Hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_1"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_1;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_2"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_3"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'\n    globalThis.Hologram ??= {};\n    globalThis.Hologram._pendingJsInteropActions = [];\n    globalThis.Hologram.assetManifest = $ASSET_MANIFEST_JS_PLACEHOLDER;\n    globalThis.Hologram.csrfToken = "',
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("csrf_token"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'";\n\n    globalThis.Hologram.dispatchAction = function(actionName, target, params) {\n      globalThis.Hologram._pendingJsInteropActions.push([actionName, target, params]);\n    }\n  ',
																		),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_4"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			"\n    \n      globalThis.Hologram.pageMountData = (deps) => {\n        const Type = deps.Type;\n        \n        return {\n          componentRegistry: $COMPONENT_REGISTRY_JS_PLACEHOLDER,\n          pageModule: $PAGE_MODULE_JS_PLACEHOLDER,\n          pageParams: $PAGE_PARAMS_JS_PLACEHOLDER\n        };\n      };\n    ",
																		),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_5"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_5;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_6"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_7"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"asset_path/1"
																					](
																						Type.bitstring(
																							"hologram/runtime.js",
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_8"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"page_bundle_path/1"
																					](
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("page_digest"),
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.Hologram.return;
				},
			},
		],
	);
};

globalThis.Hologram.pageScriptLoaded = true;
document.dispatchEvent(new CustomEvent("hologram:pageScriptLoaded"));

console.debug(
	"Hologram: page script executed in",
	PerformanceTimer.diff(startTime),
);
